import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import LoadertWrapper from './styles/loader.style';

class Loader extends Component {
	constructor(props) {
        super(props);
        this.state={
           
        }
    }

	render() {
		return (
            <LoadertWrapper>
                <div className="loader">
                    <div className="loader-icon-wrapper" style={{display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center"}}>
                        <div className="loader-icon"></div>
                        <p>Please wait for the owner to start the room</p>
                    </div> 
                </div>
            </LoadertWrapper>
        )
    }
}

export default connect()(Loader);